// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 640px) {
  .\\------packages-arch-responsive-kit-src-components-layout-responsive-module__grid-cols-1-KkEGw2 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
    display: grid;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid-cols-1": `------packages-arch-responsive-kit-src-components-layout-responsive-module__grid-cols-1-KkEGw2`,
	"gridCols1": `------packages-arch-responsive-kit-src-components-layout-responsive-module__grid-cols-1-KkEGw2`
};
export default ___CSS_LOADER_EXPORT___;
